import React from 'react';
import { motion } from 'framer-motion';
const chapters = [{
  number: 'Capítulo 1',
  title: 'El Gran Despertar',
  description: 'Qué está pasando realmente en el cerebro de tu hijo. Por qué actúa así y por qué no es tu culpa.',
  items: ['Neurociencia adolescente explicada para padres', 'Cambios físicos, emocionales y sociales', 'Lo que tu hijo necesita que sepas']
}, {
  number: 'Capítulo 2',
  title: 'Lo Que Tu Hijo Ya Puede Hacer',
  description: 'Descubre las capacidades reales de tu adolescente y cómo potenciarlas en lugar de frenarlas.',
  items: ['Autonomía y toma de decisiones', 'Cómo delegar responsabilidades gradualmente', 'El error como laboratorio de aprendizaje']
}, {
  number: 'Capítulo 3',
  title: 'Cómo Iniciar la Conversación',
  description: 'Las frases exactas que abren puertas y las que las cierran para siempre. Los momentos ideales para hablar.',
  items: ['Temas difíciles: sexualidad, drogas, pares', 'Frases que funcionan vs. frases que destruyen', 'El momento y ambiente correcto']
}, {
  number: 'Capítulo 4',
  title: 'Comunicación Honesta y Directa',
  description: 'La escucha activa como superpoder. Cómo validar sin perder la autoridad. Lo que tu cuerpo comunica.',
  items: ['Técnica de escucha activa (Gottman)', 'Validar emociones sin perder límites', 'Comunicación no verbal']
}, {
  number: 'Capítulo 5',
  title: 'El Mapa del Padre Presente',
  description: 'Límites con amor y firmeza. Rutinas que conectan. Cómo celebrar logros y abrazar los errores.',
  items: ['Crianza autoritativa (Baumrind)', 'Rituales familiares que construyen identidad', 'Disciplina sin castigo emocional']
}, {
  number: 'Capítulo 6',
  title: 'Errores que Alejan',
  description: 'Control excesivo, invalidación emocional, comparaciones. Reconócelos y cámbialos antes de que alejen a tu hijo.',
  items: ['El peligro de la hiperprotección', 'Gritos, sarcasmo y castigos que dañan', 'Cómo cambiar patrones aprendidos']
}, {
  number: 'Capítulo 7',
  title: 'Paciencia y Constancia',
  description: 'Por qué criar a un adolescente es un maratón. Cómo cuidarte para poder cuidar. Construir día a día.',
  items: ['Regulación emocional parental', 'Autocuidado sin culpa', 'Los micro-momentos que lo cambian todo']
}];
export function ChaptersSection() {
  return <section className="py-20 px-5 bg-white text-center" data-id="element-19">
      <div className="max-w-5xl mx-auto" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-21">
          <div className="inline-block text-xs font-bold tracking-[3px] uppercase text-[#F4A535] mb-4" data-id="element-22">
            Lo que encontrarás dentro
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#1A2744] mb-4" data-id="element-23">
            7 Capítulos. Un Mapa Completo.
          </h2>

          <p className="text-lg text-[#718096] max-w-2xl mx-auto mb-16" data-id="element-24">
            Cada capítulo incluye ciencia, estrategias prácticas y ejercicios
            para aplicar hoy mismo.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-25">
          {chapters.map((chapter, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#F7F9FF] rounded-2xl p-7 text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(26,39,68,0.1)]" data-id="element-26">
              <div className="text-xs font-bold tracking-[2px] uppercase text-[#F4A535] mb-2" data-id="element-27">
                {chapter.number}
              </div>
              <h3 className="text-lg font-bold text-[#1A2744] mb-3" data-id="element-28">
                {chapter.title}
              </h3>
              <p className="text-sm text-[#718096] leading-relaxed mb-3" data-id="element-29">
                {chapter.description}
              </p>
              <ul className="mt-3 pl-5 space-y-1" data-id="element-30">
                {chapter.items.map((item, i) => <li key={i} className="text-xs text-[#4A5568] list-disc" data-id="element-31">
                    {item}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#F0F7FF] rounded-2xl p-8 max-w-3xl mx-auto border-l-4 border-[#F4A535]" data-id="element-32">
          <p className="text-base text-[#4A5568] m-0" data-id="element-33">
            💡{' '}
            <strong className="text-[#1A2744]" data-id="element-34">Cada capítulo incluye:</strong>{' '}
            Sección "La ciencia dice...", cuadros{' '}
            <em data-id="element-35">Qué Debes Hacer / Qué No Debes Hacer</em>, un recordatorio de
            paciencia y un <strong data-id="element-36">ejercicio práctico</strong> para aplicar hoy
            mismo.
          </p>
        </motion.div>
      </div>
    </section>;
}